var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"containerRef"},[_c('v-row',{staticClass:"px-2 ma-0"},[_c('info-competence',{attrs:{"data":_vm.individualCompetence,"title":_vm.$gettext('Comparativa')}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }